"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _ScreenPlaceholder = require("../../molecules/ScreenPlaceholder");
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}
var ChatPlaceholderAdExpired = function ChatPlaceholderAdExpired() {
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_ScreenPlaceholder.ScreenPlaceholder, {
    title: "Este an\xFAncio expirou ou j\xE1 foi vendido",
    text: "Mas temos muitos outros como esse, busca l\xE1 ;)"
  });
};
var _default = exports["default"] = ChatPlaceholderAdExpired;